// export const apiUrl = "https://180b-103-244-178-85.eu.ngrok.io"; // live bhau
// export const apiUrl = "https://jobster-apis.herokuapp.com"; // hamza bhau
export const apiUrl = "https://jobster-prod.herokuapp.com"; // hamza bhau`

export const imageUrl = `${apiUrl}/api/images/`;
export const pdfUrl = `${apiUrl}/api/pdf/`;

export const URL = (link) => {
  return `${apiUrl}/api/${link}`;
};

export const apiHeader = (token, isFormData) => {
  if (token && !isFormData) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
  }
  if (token && isFormData) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        // Accept: 'application/json',
        "Content-Type": "multipart/form-data",
      },
    };
  }
  if (!token && !isFormData) {
    return {
      headers: {
        "Content-Type": "application/json",
      },
    };
  }

  if (!token && isFormData) {
    return {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
  }
};

export const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export var recordsLimit = 30;

export const firebaseVapidObject = {
  vapidKey:
    "BKlmZ2T6iSDR1mOAaQOzBEbwHdlYX71OqZOwvvja_oDliCf9eRrb8Rgo_dasRs9WCpgSppH0O0kvtIOc959bO0U",
};

export const fallBackCompanyCover =
  "data:image/jpeg;base64,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";

export const fallbackUser =
  "https://cdn-icons-png.flaticon.com/512/847/847969.png";
export const dollarRegEx = /^\$?[0-9]+(\.[0-9][0-9])?$/;
